export const onFormikTextChangesValidation = (
  formik: any,
  field: string,
  orElse?: string
) => (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value ?? orElse ?? '';

  formik.setFieldTouched(field, true, false);
  formik.setFieldValue(field, value);
  formik.setFieldValue(field, value).then(() => {
    formik.validateField(field);
  }); 
};
